const es = {
  common: {
    loading: "Cargando...",
    close: "Cerrar",
    submit: "Enviar",
    review: "Revisar",
    help: "Ayuda",
    tour: "Recorrido",
    instructions: "Instrucciones",
    language: "Idioma",
    ok: "Aceptar",
    appLoaderText:
      "Cargando... Por favor espera mientras preparamos tu entorno de evaluación."
  },
  assessment: {
    toast: {
      proctoringViolationDetected: "Se detecto una infraccion de supervision",
      messages: {
        forbiddenObjectDetected: "Se detecto un objeto prohibido",
        noFaceDetected: "No se detecto ningun rostro",
        multipleFacesDetected: "Se detectaron multiples rostros",
        lookingAwayFromScreen: "Mirando fuera de la pantalla",
        notLookingAtScreen: "No estas mirando la pantalla",
        faceNotOrientedCorrectly: "El rostro no esta orientado correctamente",
        eyesNotFullyOpen: "Los ojos no estan completamente abiertos",
        copyNotAllowed: "No se permite copiar",
        cutRestricted: "Cortar esta restringido en el modo de supervision",
        pasteNotAllowed: "No se permite pegar",
        contextMenuNotAllowed: "No se permite abrir el menu contextual"
      }
    },
    fetchError: "Error al cargar {{featureName}}",
    somethingWentWrong: "Algo salio mal.",
    goBackToDashboard: "Volver al panel",
    confirmSubmissionTitle: "Confirmar envio",
    scheduleIdNotFound: "No se encontro Schedule Id",
    ongoingIdNotFound: "No se encontro Ongoing Id",
    errorFetchingOngoingData: "Error al obtener datos en curso",
    connectionRestoredLabel: "Conexion restaurada.",
    connectionRestoredDescription: "Puedes seguir ejecutando casos de prueba.",
    connectionLostLabel: "Se perdio la conexion con el servidor de pruebas.",
    connectionLostDescription:
      "No podras ejecutar ni validar casos de prueba por ahora.",
    featureNames: {
      assessment: "Evaluacion",
      knowledgeCheck: "Verificacion de conocimiento"
    },
    cardStatus: {
      na: "N/A",
      toBeLaunched: "Por iniciar",
      expired: "Expirada",
      expiringSoon: "Finaliza pronto",
      ongoing: "En curso"
    },
    cardState: {
      draft: "Borrador",
      published: "Publicado",
      cancelled: "Cancelado",
      inreview: "En revisión",
      readytopublish: "Listo para publicar",
      sentback: "Devuelto"
    },
    dashboard: {
      videoProctoring: "Supervision por video",
      submitFeature: "Enviar {{featureName}}",
      noSectionsFound: "No se encontraron secciones",
      expandAllSections: "Expandir todas las secciones",
      closeAllSections: "Cerrar todas las secciones",
      continueShapingAssessments: "Sigue dando forma a tus evaluaciones",
      viewAll: "Ver todo",
      legend: {
        notStarted: "No iniciado",
        inProgress: "En progreso",
        completed: "Completado"
      }
    },
    confirmModal: {
      description:
        "Una vez enviado, no podras hacer cambios en tu {{featureName}}. Revisa tus respuestas antes de confirmar. Quieres continuar con el envio?",
      lowWordCountWarning:
        "Tu respuesta para la pregunta {{questionTitle}} tiene menos de 40 palabras. Si envias ahora, esta respuesta no se guardara.",
      videoNotSubmittedWarning:
        "Tu video grabado para la pregunta {{questionTitle}} no se envio. Si envias ahora, esta respuesta se descartara.",
      unansweredQuestions: "Tienes {{count}} preguntas sin responder",
      andFlaggedQuestions: "y {{count}} preguntas marcadas",
      failedToFinish: "No se pudo finalizar {{featureName}}"
    },
    feedback: {
      submittedTitle: "Tu {{featureName}} se ha enviado exitosamente!",
      submittedDescription:
        "Tus respuestas han sido enviadas. Agradecemos el tiempo y esfuerzo que has dedicado a completar este {{featureName}}!",
      resultInProgress:
        "El resultado se esta calculando y puede tardar hasta un minuto. Por favor espera...",
      resultReady:
        "El resultado esta listo! Haz clic en Mostrar resultado para verlo.",
      resultDelayed:
        "El calculo del resultado esta tardando mas de lo usual. Por favor contacta al administrador para tu resultado.",
      showResult: "Mostrar resultado",
      redirectingToResult:
        "Redirigiendo a la pagina de resultados en {{seconds}} segundos si no haces clic en Mostrar resultado",
      shareFeedbackTitle: "Comparte tu opinion",
      shareFeedbackDescription:
        "Tus comentarios abren el camino al crecimiento. Mejoremos juntos!",
      errorSubmittingFeedback: "Error al enviar la opinion",
      feedbackSubmittedTitle: "Listo, opinion enviada!",
      feedbackSubmittedDescription:
        "Tu opinion ha sido enviada. Gracias por ayudarnos a mejorar la experiencia de {{featureName}}!",
      feedbackAlreadySubmittedTitle: "Listo, opinion ya enviada!",
      feedbackAlreadySubmittedDescription:
        "Parece que ya enviaste tu opinion. Gracias por ayudarnos a mejorar la experiencia de {{featureName}}!"
    },
    page: {
      errorFetchingPreAssessmentData:
        "Error al obtener datos previos a la evaluacion",
      connectionRestoredLabel: "Conexion restaurada.",
      connectionRestoredDescription: "Sincronizando tus ultimos cambios...",
      offlineLabel: "Parece que estas sin conexion.",
      offlineDescription:
        "Los cambios no se sincronizaran hasta que te reconectes"
    },
    question: {
      questions: "Preguntas",
      closeQuestionsPanel: "Cerrar panel de preguntas",
      collapse: "Contraer",
      sectionSummary: "Resumen de seccion",
      sections: "Secciones",
      toggleQuestionsPanel: "Alternar panel de preguntas",
      switchModal: {
        switchQuestionButton: "Cambiar pregunta",
        leaveHeading: "Estas seguro de que quieres salir?",
        discardMessage:
          "Tienes cambios sin guardar. Si cambias de pregunta, tu respuesta se eliminara permanentemente.",
        saveChangesButton: "Guardar cambios",
        saveHeading: "Quieres guardar los cambios?",
        saveBeforeSwitchMessage:
          "Tienes cambios sin guardar. Te gustaria guardarlos antes de cambiar de pregunta?"
      }
    },
    faq: {
      q1: {
        question: "Que debo hacer antes de comenzar {{featureName}}?",
        firstSentence: "Asegurate de haber completado lo siguiente:",
        list: {
          item1: "Una conexion a internet estable",
          item2:
            "Una camara web y un microfono funcionando (si la supervision por video esta habilitada)",
          item3: "Un entorno tranquilo y sin distracciones",
          item4:
            "Si la supervision por video esta habilitada, se te pedira completar una revision del sistema.",
          item5: "Lee y acepta los terminos y condiciones"
        }
      },
      q2: {
        question:
          "Puedo navegar entre preguntas o secciones durante {{featureName}}?",
        firstSentence: "La navegacion depende de la configuracion.",
        list: {
          item1:
            "Si la navegacion por secciones esta habilitada, puedes moverte entre secciones.",
          item2:
            "Si esta deshabilitada, deberas completar una seccion antes de pasar a la siguiente."
        },
        lastSentence:
          "Las instrucciones estaran disponibles en todo momento durante {{featureName}}."
      },
      q3: {
        question: "Sere supervisado durante la prueba?",
        list: {
          item1:
            "Si {{featureName}} tiene supervision por video habilitada, se usaran tu camara y microfono.",
          item2: "Cualquier actividad inusual puede marcarse para revision."
        }
      },
      q4: {
        question:
          "Que pasa si pierdo la conexion a internet o cierro el navegador por accidente?",
        firstSentence: "Tu progreso se guarda automaticamente.",
        lastSentence:
          "Si ocurre una desconexion, puedes volver a unirte a {{featureName}} usando el mismo enlace."
      },
      q5: {
        question:
          "Podre ver mis resultados o comentarios despues de la prueba?",
        firstSentence:
          "Los resultados y comentarios los configura el organizador de {{featureName}}.",
        list: {
          item1:
            "Si esta habilitado, veras tu puntuacion y un resumen de comentarios despues del envio.",
          item2:
            "Si no, tus resultados se compartiran a traves de tu correo electronico registrado."
        }
      }
    },
    labels: {
      totalDuration: "Duracion total",
      numberOfQuestions: "No. de preguntas",
      numberOfSections: "No. de secciones",
      guidelines: "Pautas",
      platformHelp: "Ayuda de plataforma",
      faq: "Preguntas frecuentes",
      frequentlyAskedQuestions: "Preguntas frecuentes",
      showFeatureInstructions: "Mostrar instrucciones de {{featureName}}",
      minutes: "minutos",
      welcome: "Bienvenido",
      welcomeBack: "Bienvenido de nuevo",
      userFallback: "Usuario",
      defaultGuidelines:
        "Antes de comenzar {{featureName}}, asegurate de estar en un lugar tranquilo, sin distracciones y con conexion estable a internet. Mantén la camara encendida durante toda la prueba y administra bien tu tiempo. Si tienes problemas tecnicos, contacta soporte inmediatamente. Revisa tus respuestas antes de enviar. Buena suerte!"
    },
    zoom: {
      textSize: "Tamano de texto:",
      decreaseTextSize: "Reducir tamano de texto (A-)",
      resetTextSize: "Restablecer tamano de texto (A)",
      increaseTextSize: "Aumentar tamano de texto (A+)",
      decreaseInterfaceSize: "Reducir tamano de interfaz",
      resetInterfaceSize: "Restablecer tamano de interfaz",
      increaseInterfaceSize: "Aumentar tamano de interfaz"
    },
    wrapper: {
      warningTitle: "Advertencia!",
      stayOnPageMessage:
        "Por favor permanece en esta pagina hasta completar {{featureName}}.",
      iUnderstand: "Entendido",
      submitTheFeature: "Enviar {{featureName}}",
      videoProctoringInterrupted: "Supervision por video interrumpida",
      continuationBlocked:
        "La continuacion de la evaluacion esta bloqueada hasta que se restaure la supervision segura por video.",
      retryProctoring: "Reintentar supervision"
    },
    progress: {
      proceed: "Continuar",
      resumeFeature: "Reanudar {{featureName}}",
      timeRemainingMessage:
        "restante en {{featureName}}. Haz clic abajo para continuar donde lo dejaste.",
      continueOnThisDevice: "Continuar en este dispositivo?",
      switchToThisTab: "Cambiar a esta pestana?",
      continueYourAssessmentHere: "Continuar tu evaluacion aqui?",
      switchHere: "Cambiar aqui",
      attemptsUnlimited:
        "Tienes intentos ilimitados disponibles para esta evaluacion.",
      attemptsSingle:
        "Tienes <strong>1</strong> intento disponible para esta evaluacion.",
      attemptsMultiple:
        "Tienes <strong>{{remainingAttempts}}</strong> de <strong>{{maxAttempts}}</strong> intentos disponibles para esta evaluacion.",
      coolOffAfterAttempt:
        "Despues de cada intento, necesitaras esperar <strong>{{coolOffTime}}</strong> antes de comenzar tu proximo intento."
    },
    loginWindow: {
      expiredTitle: "Tiempo de inicio de sesion expirado",
      expiredMessage:
        "La ventana de inicio de sesion para este {{featureName}} esta cerrada. Perdiste el tiempo permitido para acceder a la prueba."
    },
    coding: {
      saving: "Guardando",
      offlineTitle: "Parece que estas sin conexion",
      offlineDescription:
        "Los cambios no se sincronizaran hasta que te reconectes",
      connectionRestored: "Conexion restaurada",
      syncingLatest: "Sincronizando tus ultimos cambios...",
      autoSaveEnabled: "Guardado automatico activado",
      runOnlyChecksDescription: "solo verifica tu código con casos de prueba.",
      submitEvaluationDescription:
        "tu código para que sea evaluado y recibir una puntuación.",
      reset: "Restablecer",
      run: "Ejecutar",
      runTests: "Ejecutando pruebas",
      submit: "Enviar",
      submitting: "Enviando",
      resetCode: "Restablecer codigo",
      resetCodeMessage:
        "Esta seguro de que desea restablecer? Esto eliminara todo tu codigo actual y restaurara el codigo inicial",
      testCases: "Casos de prueba",
      testCase: "Caso de prueba {{index}}",
      testCasePassed: "Caso de prueba aprobado",
      testCaseFailed: "Caso de prueba fallido",
      runtimeError: "Error de ejecucion",
      timeLimitExceeded: "Limite de tiempo excedido",
      timeLimitExceededTitle: "Limite de tiempo excedido",
      timeLimitExceededDescription:
        "Tu codigo no se ejecuto dentro de los limites de tiempo. Por favor optimiza tu codigo.",
      input: "Entrada",
      expectedOutput: "Salida esperada",
      yourOutput: "Tu salida",
      hiddenTestCase: "Caso de prueba oculto",
      hiddenTestCaseDescription:
        "Los casos de prueba ocultos se usan para evaluar si tu codigo puede manejar diferentes escenarios incluyendo casos extremos",
      explanation: "Explicacion",
      hints: "Pistas"
    },
    subjective: {
      minWordsRequired:
        "Se requieren minimo 40 palabras para enviar la respuesta.",
      enterYourAnswer: "Escribe tu respuesta",
      submitResponse: "Enviar respuesta",
      submittingResponse: "Enviando respuesta...",
      resetAnswer: "Restablecer respuesta",
      resetAnswerMessage:
        "Esta seguro de que desea restablecer? Tu respuesta actual se eliminara permanentemente.",
      retake: "Volver a tomar",
      showHint: "Mostrar pista",
      recording: "GRABANDO"
    },
    systemCheck: {
      calibrate: "Calibrar",
      calibrating: "Calibrando...",
      accessDenied: "Acceso denegado",
      cameraPermissionDenied:
        "Permiso de camara denegado. Habilita el acceso a la camara en la configuracion de tu navegador para continuar.",
      errorFetchingDevices: "Error al obtener dispositivos",
      failedToStartAssessment: "No se pudo iniciar la evaluacion",
      unableToStartSecureProctoring:
        "No se pudo iniciar la supervision segura en este momento. Vuelve a intentarlo.",
      unnamedCamera: "Camara sin nombre",
      facingCalibrationIssues: "Tienes problemas con la calibracion de video?",
      lookAtCenter: "Mira al centro de la pantalla y permanece quieto.",
      unableToCalibrateTitle:
        "No se puede calibrar la camara para la supervision por video?",
      statusMessages: {
        readyForCalibration:
          "Asegurate de que tu rostro sea claramente visible y este centrado en la pantalla. Cuando estes listo, haz clic en 'Calibrar' para comenzar.",
        calibratingInProgress:
          "Calibracion en progreso. Sigue mirando la pantalla.",
        calibratingTimedOut:
          "Se agoto el tiempo de calibracion de la camara. Actualiza tu navegador para continuar.",
        preparingCameraPreview:
          "Preparando el flujo de camara y el seguimiento facial para la calibracion.",
        retryRequired:
          "La configuracion de supervision requiere tu accion antes de continuar.",
        proctoringUnavailable:
          "La supervision no esta disponible actualmente y la evaluacion no puede comenzar de forma segura.",
        calibrationCompleted:
          "Calibracion exitosa. Ya esta todo listo para comenzar la evaluacion.",
        timeoutHelp:
          "Si aun ves este mensaje, revisa otras pestanas/aplicaciones que esten usando la camara o un obturador externo."
      },
      failureReasons: {
        cameraPermissionDenied:
          "El permiso de camara esta bloqueado. Permite el acceso y vuelve a intentarlo.",
        cameraUnavailable:
          "La camara no esta disponible. Revisa la seleccion de dispositivo y vuelve a intentarlo.",
        facemeshInitFailed:
          "Fallo la configuracion del seguimiento facial. Vuelve a intentarlo para continuar.",
        cocoLoadFailed:
          "El motor de supervision no esta disponible. Actualiza e intentalo de nuevo.",
        streamLostReacquireFailed:
          "Fallo la recuperacion del flujo de camara. Reintenta la supervision.",
        calibrationInsufficientData:
          "Las muestras de calibracion fueron insuficientes. Reintenta la calibracion.",
        detectionCadenceUnavailable:
          "La configuracion de temporizacion no esta lista. Reintenta en breve."
      },
      calibrationInfo: {
        heading: "Para calibrar correctamente tu video, sigue estos pasos:",
        followUpHeading: "Si aun tienes el problema, sigue estos pasos:",
        initialSteps: {
          step1: {
            title: "Asegura una buena iluminacion",
            description:
              "Sientate en un lugar bien iluminado con tu rostro claramente visible. Evita luz intensa o ventanas detras de ti."
          },
          step2: {
            title: "Mira directamente a la camara",
            description:
              "Coloca tu rostro en el centro del encuadre y mira directamente a la camara durante la calibracion."
          },
          step3: {
            title: "Evita fondos oscuros o borrosos",
            description:
              "Asegurate de que tu fondo sea claro y no demasiado oscuro."
          },
          step4: {
            title: "Verifica permisos de camara",
            description:
              "Permite que tu navegador acceda a la webcam cuando se solicite."
          },
          step5: {
            title: "Mantente quieto y mira la pantalla",
            description:
              "Mantén tu cabeza estable durante la calibracion para ayudar al sistema a detectar tu rostro correctamente."
          }
        },
        laterSteps: {
          step1: "Intenta actualizar la pagina y recalibrar tu camara.",
          step2:
            "Cierra otras aplicaciones que usen la webcam (como Zoom o Teams).",
          step3:
            "Si el problema continua, contacta a {{contactEmail}} con una captura del error."
        }
      }
    },
    stepper: {
      termsAndConditions: "Terminos y condiciones",
      agreeTerms: "He leido y acepto los terminos y condiciones.",
      previousStep: "Paso anterior",
      nextStep: "Siguiente paso",
      startAssessment: "Iniciar evaluacion",
      resumeAssessment: "Reanudar evaluacion",
      mediaCheck: "Revision de medios",
      systemCheck: "Revision del sistema",
      audioCheck: {
        intro:
          "Puedes grabar un video corto aqui para verificar que tu camara y microfono funcionen como se espera",
        mediaPermissionDenied:
          "Se denego el acceso a la camara o al microfono. Habilita los permisos en la configuracion del navegador.",
        startRecording: "Iniciar grabacion",
        stopRecording: "Detener grabacion",
        unnamedMicrophone: "Microfono sin nombre"
      },
      stepLabel: "PASO {{step}}",
      personalDetails: "Datos personales",
      emailId: "Correo electronico",
      firstName: "Nombre",
      lastName: "Apellido",
      defaultTncStatement:
        "Al participar en esta evaluacion, confirmas que cumples con los requisitos de elegibilidad especificados por la empresa y aceptas completar la prueba de forma independiente, sin ayuda externa. La evaluacion esta sujeta a supervision por video y debes mantener la camara encendida durante toda la sesion en un entorno sin distracciones. Todo el contenido y los materiales proporcionados durante la evaluacion son confidenciales y no deben compartirse, reproducirse ni distribuirse. Aceptas cumplir con el limite de tiempo designado para la evaluacion; no enviar antes de la fecha limite puede resultar en descalificacion. La empresa no es responsable de problemas tecnicos relacionados con tu conexion a internet, software o hardware. Los datos personales recopilados durante la evaluacion se procesaran solo para fines de evaluacion y reclutamiento, de acuerdo con la politica de privacidad de la empresa. Cualquier intento de hacer trampa, plagiar o incurrir en conductas no eticas llevara a una descalificacion inmediata. Al enviar tus respuestas, confirmas que son finales y no se pueden realizar revisiones despues del envio. La empresa se reserva el derecho de modificar o actualizar estos terminos en cualquier momento, y se notificara a los participantes sobre cualquier cambio significativo.",
      okay: "Aceptar"
    },
    access: {
      cancelledTitle: '"{{title}}" ha sido cancelado',
      cancelledDescription:
        "Esta evaluacion ya no esta activa y no se puede acceder. Revisa tu panel para otras evaluaciones asignadas o proximas.",
      goToHome: "Ir al inicio",
      refreshPage: "Actualizar pagina"
    },
    errorPage: {
      goBack: "Volver",
      raiseRequest: "Crear solicitud",
      retryLogin: "Reintentar inicio de sesion",
      contactUs: "Contactanos",
      goBackToEvent: "Volver al evento",
      launchCourse: "Lanzar curso",
      created: "Creado",
      starts: "Inicia",
      ends: "Finaliza",
      untitled: "Sin titulo"
    },
    sidebar: {
      home: "Inicio",
      quickAccess: "Acceso rapido",
      questionPaperAuthoring: "Autoria de cuestionarios",
      assessmentLibrary: "Biblioteca de evaluaciones",
      scheduleInterview: "Programar entrevista",
      generateQuestions: "Generar preguntas",
      roleManagement: "Gestion de roles",
      logout: "Cerrar sesion",
      noAccess: "Sin acceso",
      noAccessWithLabel: "{{label}} (Sin acceso)",
      noAccessToLink: "No tienes acceso a este enlace",
      expandSidebar: "Expandir barra lateral",
      collapseSidebar: "Contraer barra lateral",
      expand: "Expandir",
      collapse: "Contraer",
      myPreferences: "Mis preferencias"
    },
    timesUp: {
      title: "Tiempo de evaluacion completado",
      autoSubmittedMessage:
        "El tiempo ha expirado. Tus respuestas han sido guardadas y {{featureName}} se ha enviado automaticamente."
    },
    resultCard: {
      title: "Resultados de {{featureName}}",
      score: "Puntuacion",
      passPercentage: "Porcentaje de aprobacion",
      marksAway:
        "Te faltan {{count}} puntos para la certificacion. Enfocate en las areas recomendadas e intentalo de nuevo.",
      certificationEarned:
        "Superaste los requisitos de certificacion y obtuviste tu certificacion",
      congratulationsOnEarning:
        "Felicitaciones por obtener la certificacion de {{featureName}}",
      almostThereTitle:
        "Estas mas cerca de lo que crees de obtener la certificacion",
      certificatePassedDescription:
        "Has demostrado los conocimientos y habilidades necesarios para lograr esta certificacion. Toma un momento para celebrar este logro y compartirlo con tu red.",
      certificateFailDescription:
        "Este intento mostro oportunidades para fortalecer tus habilidades. Revisa las areas recomendadas y vuelve con confianza.",
      congratsImageAlt: "Imagen de felicitaciones",
      almostThereImageAlt: "Imagen de casi lo logras"
    },
    sectionCard: {
      section: "Sección",
      startSection: "Iniciar sección",
      continueSection: "Continuar sección",
      completed: "Completado",
      viewSection: "Ver sección",
      totalQuestions: "Preguntas totales:",
      sectionNotFound: "Sección no encontrada.",
      total: "Total",
      flagged: "Marcado"
    },
    sectionSummary: {
      totalQuestions: "Preguntas totales",
      completedQuestions: "Preguntas completadas",
      flaggedQuestions: "Preguntas marcadas",
      unattemptedQuestions: "Preguntas sin intentar",
      codingQuestions: "Preguntas de codigo:",
      objectiveQuestions: "Preguntas objetivas:",
      goToSections: "Ir a secciones",
      lowWordCountWarning:
        "Tu respuesta para la pregunta {{questionTitle}} tiene menos de 40 palabras. Si vuelves a la lista de secciones, esta respuesta se descartara.",
      videoNotSubmittedWarning:
        "Tu video grabado para la pregunta {{questionTitle}} no ha sido enviado. Si vuelves a la lista de secciones, esta respuesta se descartara."
    },
    objective: {
      questionCounter: "Pregunta",
      marks: "Puntos :",
      explanation: "Explicacion",
      hints: "Pistas",
      reset: "Restablecer",
      flag: "Marcar",
      unflag: "Desmarcar",
      previous: "Anterior",
      saveAndNext: "Guardar y siguiente",
      saveAndViewSummary: "Guardar y ver resumen de seccion",
      next: "Siguiente",
      viewSectionSummary: "Ver resumen de seccion",
      hideExplanation: "Ocultar explicacion",
      showExplanation: "Mostrar explicacion",
      hintWaitTooltip: "Debes esperar antes de ver otra pista",
      noHintsPendingTooltip: "No hay pistas pendientes",
      selectOptionForExplanation:
        "Selecciona una opcion para ver la explicacion de la opcion seleccionada"
    },
    tour: {
      shared: {
        timer:
          "Este temporizador muestra el tiempo restante de tu evaluacion. Supervisa este valor para asegurarte de completar todas las secciones dentro del tiempo asignado.",
        submit:
          "Una vez que completes todas las secciones de la evaluacion, puedes enviar tu trabajo haciendo clic en el boton 'Enviar evaluacion'. Esta accion finaliza tus respuestas y ya no podras realizar cambios despues del envio. Asegurate de revisar todas tus respuestas antes de continuar con el envio."
      },
      dashboard: {
        legend:
          "La leyenda de estado de secciones te ayuda a entender tu progreso durante la evaluacion. Usa indicadores claros para mostrar si una seccion no ha comenzado, esta en progreso o ya fue completada. Esto te permite identificar rapidamente que partes requieren atencion y gestionar mejor tu tiempo.",
        sectionCard:
          "La tarjeta de seccion ofrece una vista detallada de cada seccion de la evaluacion. Muestra el titulo de la seccion, su estado actual y datos clave sobre las preguntas de esa seccion. Incluye el total de preguntas, cuantas estan marcadas y cuantas se han completado. Te ayuda a monitorear tu progreso e identificar areas que requieren mayor atencion."
      },
      coding: {
        titles:
          "En la parte superior de la pagina veras claramente el titulo de la evaluacion y el titulo de la seccion. Esto te ayuda a mantener el contexto de tu tarea actual y saber en que seccion estas trabajando. Usa estos titulos como referencia mientras navegas por las preguntas.",
        sectionsButton:
          "Este boton te permite volver facilmente al panel de secciones. Usalo para regresar a la vista principal de tu evaluacion, donde puedes ver y gestionar el progreso de todas las secciones. Es una forma rapida de revisar tu avance general sin perder tu trabajo actual.",
        sidebar:
          "La barra lateral muestra una vista general de todas las preguntas de la seccion actual. Te permite navegar rapidamente entre preguntas seleccionando el bloque correspondiente. Cada bloque esta codificado por color segun su estado, lo que facilita seguir tu progreso y saltar a preguntas especificas cuando sea necesario.",
        questionCard:
          "Esta tarjeta contiene la pregunta en la que estas trabajando actualmente, mostrando el enunciado completo y cualquier instruccion o requisito de entrada relevante. Esta disenada para darte una vista clara de la tarea con toda la informacion necesaria para avanzar. Tambien encontraras un boton para marcar la pregunta y revisarla despues. Ademas, hay botones de navegacion para avanzar o retroceder entre preguntas sin volver a la barra lateral, permitiendo un flujo mas eficiente durante la evaluacion.",
        editor:
          "El editor de codigo es el lugar donde escribes y modificas tus soluciones. Puedes cambiar entre diferentes lenguajes de programacion segun los requisitos de cada pregunta. Tambien puedes ajustar el tema del editor para una experiencia mas comoda. Si necesitas mas espacio, puedes expandir el editor a ancho completo para trabajar con mayor comodidad. Estas funciones estan pensadas para ofrecer un entorno flexible y amigable mientras completas tus tareas de programacion."
      }
    },
    whatsNext: {
      heading: "Que sigue?",
      attemptsRemaining: "intentos restantes",
      passed: {
        shareLinkedInTitle: "Compartir en LinkedIn",
        shareLinkedInSubtitle: "Celebra tu logro con tu red profesional.",
        viewCertificateTitle: "Ver certificado",
        viewCertificateSubtitle:
          "Descarga o accede a tu certificacion en cualquier momento.",
        shareGloTitle: "Compartir experiencia",
        shareGloSubtitle:
          "Inspira a tus colegas compartiendo internamente tu logro."
      },
      failed: {
        reviewLearningResourcesTitle: "Revisar recursos de aprendizaje",
        reviewLearningResourcesSubtitle:
          "Fortalece la habilidad que necesita atencion.",
        retakeAssessmentTitle: "Repetir evaluacion",
        retakeAssessmentSubtitle:
          "Demuestra tu progreso y comprension actualizada."
      },
      modal: {
        title: "Compartir logro",
        linkedInPostLabel: "Compartir en LinkedIn como publicacion",
        linkedInProfileLabel:
          "Agregar como certificacion en perfil de LinkedIn",
        gloLabel: "Compartir en Glo",
        comingSoon: "Proximamente",
        infoMessage: "Debes iniciar sesion en la plataforma para compartir."
      }
    },
    time: {
      hour_one: "{{count}} hora",
      hour_other: "{{count}} horas",
      minute_one: "{{count}} minuto",
      minute_other: "{{count}} minutos",
      hourShort: "h",
      minuteShort: "min",
      secondShort: "s"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "Se estan procesando los resultados de {{featureName}}",
        title: "Tus resultados se estan procesando",
        description:
          "Todavia estamos revisando tu {{featureName}}. Vuelve a consultar en breve!"
      },
      coolOffPeriod: {
        alt: "Periodo de espera",
        title: "El siguiente intento estara disponible pronto",
        completedAttempt: "Ya completaste un intento para esta",
        nextAttemptIntro: ". Tu proximo intento estara disponible en"
      },
      maxAttemptExceeded: {
        alt: "Intentos maximos alcanzados",
        title: "Se alcanzo el maximo de intentos",
        description:
          "Ya usaste todos los intentos disponibles para esta {{featureName}}. No se pueden realizar mas intentos."
      },
      scheduleNotStarted: {
        alt: "Horario no iniciado",
        title: "{{featureName}} aun no ha comenzado",
        scheduledPrefix: "El",
        scheduledOn: "esta programado para comenzar el",
        checkBack: "Vuelve en {{time}} o actualiza cuando inicie el horario."
      },
      scheduleTimeCompleted: {
        alt: "Horario finalizado",
        title: "La ventana de {{featureName}} se cerro",
        description:
          "El tiempo programado para esta {{featureName}} ya paso. Ya no puedes iniciar ni enviar un intento."
      }
    },
    attemptDetails: {
      allAttempts: "Todos los intentos",
      headers: {
        attempt: "Intento",
        attemptedOn: "Intentado el",
        percentage: "Porcentaje"
      },
      viewAllAttempts: "Ver todos los intentos"
    },
    survey: {
      questions: {
        q1: "En una escala del 1 al 5, que tan claras te parecieron las preguntas de {{featureName}}?",
        q2: "Senti que estaba adecuadamente preparado para los temas tratados en {{featureName}}",
        q3: "La plataforma usada para {{featureName}} fue facil de usar y funcional",
        q4: "Creo que mis respuestas mostraron de forma efectiva mis habilidades y conocimientos"
      },
      stronglyDisagree: "Totalmente en desacuerdo",
      stronglyAgree: "Totalmente de acuerdo",
      submitFeedback: "Enviar comentarios"
    },
    cameraPreview: {
      loadingAlt: "Cargando vista previa de camara",
      delayedMessage:
        "La calibracion esta tardando mas de lo esperado debido a una red lenta. Espera o intenta actualizar la pagina."
    },
    proctoring: {
      engineLoadFailedStatus: "No se pudo cargar el motor de supervision",
      runtimeErrors: {
        cameraPermissionDenied:
          "El acceso a la camara esta bloqueado por la configuracion de permisos del navegador.",
        cameraUnavailable:
          "La camara no esta disponible o esta siendo usada por otra aplicacion.",
        unableToLoadModel:
          "No se pudo cargar el modelo de deteccion de objetos para supervision.",
        webglRecoveryFailed:
          "La recuperacion de WebGL fallo al restaurar la deteccion de objetos."
      },
      logs: {
        engineLoadFailed: "No se pudo cargar ProctoringEngine:",
        videoPlayRejected: "Video play() fue rechazado:",
        cameraTrackEnded: "La pista de camara termino - intentando recuperarla",
        cameraReacquired: "Camara recuperada en el intento {{attempt}}",
        cameraReacquireAttemptFailed:
          "Fallo el intento {{attempt}} de recuperar la camara:",
        cameraReacquireFailedAll:
          "Fallo la recuperacion de camara tras todos los intentos - se reportara cameraDisconnected en cada ciclo",
        uploadFailedQueued:
          "La carga de supervision fallo tras {{attempts}} intentos, se encola para reintentar:",
        uploadAttemptFailedRetrying:
          "Fallo el intento {{attempt}} de carga de supervision, reintentando...",
        drainedQueuedViolation:
          "Infraccion en cola drenada: {{violationType}} (quedan {{remaining}})",
        queueDrainFailed:
          "Fallo el drenaje de la cola, se reintentara en el siguiente ciclo:",
        cocoLoadFailed: "Fallo la carga de COCO-SSD:",
        faceProcessingError: "Error al procesar rostro:",
        errorProcessingFrame: "Error al procesar fotograma:",
        faceMeshInitError: "Error al inicializar Face Mesh:"
      }
    }
  }
} as const;

export default es;
